import { render, staticRenderFns } from "./PlazosImpagadosFilters.vue?vue&type=template&id=510ca92c"
import script from "./PlazosImpagadosFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./PlazosImpagadosFilters.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports